if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          desktopArrows: null,
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.desktopSlideDirection = 0;
        this.setupDesktopMediaArrows();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      setupDesktopMediaArrows() {
        if (!this.elements.viewer || this.elements.viewer.querySelector('.product-media-gallery__desktop-arrows')) return;

        const sourceControls = Array.from(this.elements.viewer.children).find((element) =>
          element.classList.contains('slider-buttons')
        );
        if (!sourceControls) return;

        const sourcePreviousButton = sourceControls.querySelector('button[name="previous"]');
        const sourceNextButton = sourceControls.querySelector('button[name="next"]');
        if (!sourcePreviousButton || !sourceNextButton) return;

        const desktopArrows = document.createElement('div');
        const previousButton = sourcePreviousButton.cloneNode(true);
        const nextButton = sourceNextButton.cloneNode(true);

        desktopArrows.className = 'product-media-gallery__desktop-arrows';
        previousButton.classList.add('product-media-gallery__desktop-arrow');
        nextButton.classList.add('product-media-gallery__desktop-arrow');
        previousButton.removeAttribute('disabled');
        nextButton.removeAttribute('disabled');

        desktopArrows.append(previousButton, nextButton);
        this.elements.viewer.appendChild(desktopArrows);
        this.elements.desktopArrows = desktopArrows;

        this.injectDesktopMediaArrowStyles();
        previousButton.addEventListener('click', this.onDesktopArrowClick.bind(this));
        nextButton.addEventListener('click', this.onDesktopArrowClick.bind(this));
        this.updateDesktopGalleryArrows();
      }

      injectDesktopMediaArrowStyles() {
        if (document.getElementById('product-media-gallery-desktop-arrows-style')) return;

        const style = document.createElement('style');
        style.id = 'product-media-gallery-desktop-arrows-style';
        style.textContent = `
          @media screen and (min-width: 750px) {
            media-gallery [id^="GalleryViewer"] {
              position: relative;
            }

            media-gallery [id^="Slider-Gallery"] {
              position: relative;
              overflow: hidden;
            }

            media-gallery .product-media-gallery__desktop-arrows {
              pointer-events: none;
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              z-index: 5;
              display: flex !important;
              align-items: center;
              justify-content: space-between;
              opacity: 0;
              transform: translateY(-50%) scale(0.98);
              transition: opacity 180ms ease, transform 180ms ease;
            }

            media-gallery [id^="GalleryViewer"]:hover .product-media-gallery__desktop-arrows,
            media-gallery [id^="GalleryViewer"]:focus-within .product-media-gallery__desktop-arrows {
              opacity: 1;
              transform: translateY(-50%) scale(1);
            }

            media-gallery .product-media-gallery__desktop-arrows[hidden] {
              display: none !important;
            }

            media-gallery .product-media-gallery__desktop-arrow.slider-button {
              pointer-events: auto;
              display: flex !important;
              align-items: center;
              justify-content: center;
              width: 46px;
              height: 46px;
              margin: 0 16px;
              padding: 0;
              border: 1px solid rgba(var(--color-foreground), 0.1);
              border-radius: 50%;
              background: rgba(var(--color-background), 0.78);
              box-shadow: 0 10px 28px rgba(var(--color-foreground), 0.16);
              color: rgb(var(--color-foreground));
              cursor: pointer;
              backdrop-filter: blur(12px);
              transform: translateX(0) scale(0.92);
              transition: background 180ms ease, box-shadow 180ms ease, opacity 180ms ease, transform 180ms ease, color 180ms ease;
            }

            media-gallery .product-media-gallery__desktop-arrow--prev {
              transform: translateX(-8px) scale(0.92);
            }

            media-gallery .product-media-gallery__desktop-arrow--next {
              transform: translateX(8px) scale(0.92);
            }

            media-gallery [id^="GalleryViewer"]:hover .product-media-gallery__desktop-arrow,
            media-gallery [id^="GalleryViewer"]:focus-within .product-media-gallery__desktop-arrow {
              transform: translateX(0) scale(1);
            }

            media-gallery .product-media-gallery__desktop-arrow.slider-button:not([disabled]):hover {
              background: rgba(var(--color-background), 0.96);
              box-shadow: 0 14px 34px rgba(var(--color-foreground), 0.22);
              color: rgb(var(--color-foreground));
              transform: translateX(0) scale(1.06);
            }

            media-gallery .product-media-gallery__desktop-arrow.slider-button[disabled] {
              opacity: 0.28;
              cursor: default;
              box-shadow: 0 6px 18px rgba(var(--color-foreground), 0.1);
            }
          }

          @media screen and (max-width: 749px) {
            media-gallery .product-media-gallery__desktop-arrows {
              display: none !important;
            }
          }
        `;
        document.head.appendChild(style);
      }

      getMainMediaItems() {
        return Array.from(this.elements.viewer.querySelectorAll('[id^="Slide-"][data-media-id]'));
      }

      getActiveMainMedia(mediaItems) {
        return mediaItems.find((item) => item.classList.contains('is-active')) || mediaItems[0];
      }

      onDesktopArrowClick(event) {
        if (!this.mql.matches) return;

        event.preventDefault();

        const mediaItems = this.getMainMediaItems();
        if (mediaItems.length < 2) return;

        const activeMedia = this.getActiveMainMedia(mediaItems);
        const currentIndex = mediaItems.indexOf(activeMedia);
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        const nextMedia = mediaItems[currentIndex + direction];
        if (!nextMedia) return;

        this.desktopSlideDirection = direction;
        const thumbnail = this.elements.thumbnails
          ? Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).find(
              (item) => item.dataset.target === nextMedia.dataset.mediaId
            )
          : null;
        const thumbnailButton = thumbnail ? thumbnail.querySelector('button') : null;

        if (thumbnailButton) {
          thumbnailButton.click();
          window.setTimeout(() => this.updateDesktopGalleryArrows());
        } else {
          this.setActiveMedia(nextMedia.dataset.mediaId, false);
          this.updateDesktopGalleryArrows();
        }
      }

      animateDesktopMediaChange(previousMedia, activeMedia, direction) {
        if (!this.mql.matches || !previousMedia || !activeMedia || previousMedia === activeMedia || !direction) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (typeof activeMedia.animate !== 'function') return;

        const slider = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        if (!slider) return;

        const height = Math.max(previousMedia.offsetHeight, activeMedia.offsetHeight);
        const distance = 56 * direction;
        const previousStyles = {
          display: previousMedia.style.display,
          position: previousMedia.style.position,
          inset: previousMedia.style.inset,
          width: previousMedia.style.width,
          zIndex: previousMedia.style.zIndex,
          pointerEvents: previousMedia.style.pointerEvents,
        };
        const activeStyles = {
          zIndex: activeMedia.style.zIndex,
        };
        const sliderMinHeight = slider.style.minHeight;

        if (height) slider.style.minHeight = `${height}px`;
        previousMedia.style.display = 'block';
        previousMedia.style.position = 'absolute';
        previousMedia.style.inset = '0';
        previousMedia.style.width = '100%';
        previousMedia.style.zIndex = '1';
        previousMedia.style.pointerEvents = 'none';
        activeMedia.style.zIndex = '2';

        previousMedia.animate(
          [
            { opacity: 1, transform: 'translateX(0)' },
            { opacity: 0, transform: `translateX(${-distance}px)` },
          ],
          { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );

        const activeAnimation = activeMedia.animate(
          [
            { opacity: 0, transform: `translateX(${distance}px)` },
            { opacity: 1, transform: 'translateX(0)' },
          ],
          { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );

        activeAnimation.finished.finally(() => {
          previousMedia.style.display = previousStyles.display;
          previousMedia.style.position = previousStyles.position;
          previousMedia.style.inset = previousStyles.inset;
          previousMedia.style.width = previousStyles.width;
          previousMedia.style.zIndex = previousStyles.zIndex;
          previousMedia.style.pointerEvents = previousStyles.pointerEvents;
          activeMedia.style.zIndex = activeStyles.zIndex;
          slider.style.minHeight = sliderMinHeight;
        });
      }

      updateDesktopGalleryArrows() {
        if (!this.elements.desktopArrows || !this.elements.viewer) return;

        const mediaItems = this.getMainMediaItems();
        const previousButton = this.elements.desktopArrows.querySelector('button[name="previous"]');
        const nextButton = this.elements.desktopArrows.querySelector('button[name="next"]');

        this.elements.desktopArrows.hidden = mediaItems.length < 2;
        if (!previousButton || !nextButton || mediaItems.length < 2) return;

        const activeMedia = this.getActiveMainMedia(mediaItems);
        const currentIndex = mediaItems.indexOf(activeMedia);
        previousButton.toggleAttribute('disabled', currentIndex <= 0);
        nextButton.toggleAttribute('disabled', currentIndex >= mediaItems.length - 1);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateDesktopGalleryArrows();
      }

      setActiveMedia(mediaId, prepend) {
        const previousActiveMedia = this.elements.viewer.querySelector('[id^="Slide-"][data-media-id].is-active');
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');
        this.animateDesktopMediaChange(previousActiveMedia, activeMedia, this.desktopSlideDirection);
        this.desktopSlideDirection = 0;

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        this.updateDesktopGalleryArrows();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
